module.exports = __webpack_public_path__ + "html/landing-template_404541639e794e34598793e5499171f6.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/landing-template.html
// module id = SjG1
// module chunks = 46